import React from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import RepeatIcon from '../assets/repeat-icon.svg?react';

const Button = styled.button`
    ${({ theme }) => css`
        display: inline-flex;
        align-items: center;
        background-color: transparent;
        outline: none;
        border: none;
        cursor: pointer;
        border-radius: 4px;
        padding: 0;

        &::-moz-focus-inner {
            border: 0;
        }

        &:focus {
            box-shadow: var(--outline);
        }

        &:active {
            box-shadow: none;
        }

        & > svg {
            fill: ${theme.colors['myzanichelli-blue-light']};
            height: 18px;
            width: 18px;
        }

        & > svg:hover {
            fill: ${theme.colors['myzanichelli-blue-dark']};
        }

        fill:;
    `}
`;

const StopButton = ({ onClick, ariaLabel, ariaControls }) => {
    return (
        <Button onClick={onClick} onMouseUp={(event) => event.target.blur()} aria-label={ariaLabel} aria-controls={ariaControls}>
            <RepeatIcon />
        </Button>
    );
};

StopButton.propTypes = {
    onClick: PropTypes.func,
    ariaLabel: PropTypes.string.isRequired,
    ariaControls: PropTypes.string.isRequired,
};

export default StopButton;
